import axios from 'axios';
import router from '../router'
import store from '../store'

const neoApi = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
  headers: {
    //rejectUnauthorized: false,
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  timeout: 15000,
});

neoApi.interceptors.request.use(async (config) => {
  try {
    const token = await localStorage.getItem('token');
    if (token) {
      // console.log('Attaching token', token);
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch (e) {
    console.log('Failed to save and attach token');
    console.log(e);
  }
  return config;
}, (error) => {
  console.log('neoApi.interceptors.request error', error);
  return error;
});

neoApi.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    console.log('neoApi.interceptors.response error', error)
    if (error.response?.status === 401 || error.response?.status === 403) {
      store.dispatch('logout')
      router.push('/login').catch(err => {
        // Ignore the vuex err regarding  navigating to the page they are already on.
        if (
          err.name !== 'NavigationDuplicated' &&
          !err.message.includes('Avoided redundant navigation to current location')
        ) {
          // But print any other errors to the console
          console.error(err);
        }
      });

    }
    // throw error;
    return Promise.reject(error)
  }
);

export default neoApi;
